import React from 'react';
import ImpactHero from '../components/mel/ImpactHero';

const Programme: React.FC = () => {
  return (
    <div className="py-4 text-gray-800 bg-[#F7F8F9] min-h-[70vh]">
      <ImpactHero />
    </div>
  );
};

export default Programme;
